import { Pipe } from '@angular/core';
import { DebtModel } from 'shared';

@Pipe({
  name: 'isExistDebt',
  standalone: true
})
export class IsExistDebtPipe {
  transform(debts: DebtModel[]): boolean {
    return debts.some(v => !v.paidOff)
  }
}
